import { render, staticRenderFns } from "./ScatterLegend.vue?vue&type=template&id=4335af91&scoped=true&"
import script from "./ScatterLegend.vue?vue&type=script&lang=js&"
export * from "./ScatterLegend.vue?vue&type=script&lang=js&"
import style0 from "./ScatterLegend.vue?vue&type=style&index=0&id=4335af91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4335af91",
  null
  
)

export default component.exports